let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iFuRL")).then(() => parcelRequire('bIVe0'));